import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS } from '../../../../../../../constants/constant';
import { CardDescription } from '../../../../ui/card';
import { Label } from '../../../../ui/label';
import { RadioGroup, RadioGroupItem } from '../../../../ui/radio-group';
const Index = ({ setSelectedSearchType, selectedSearchType, CUSTOMER_SEARCH_TYPES }: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  return (
    <CardDescription>
      <RadioGroup
        defaultValue={selectedSearchType}
        onValueChange={(value) => {
          setSelectedSearchType(value);
        }}
        className="pointer mb-5 flex"
      >
        <span className="flex items-center">
          <span className="mr-4 flex items-center">
            <RadioGroupItem
              value={CUSTOMER_SEARCH_TYPES?.phoneNumber}
              id={CUSTOMER_SEARCH_TYPES?.phoneNumber}
              className="mr-2 border-black"
            />
            <Label className="text-base font-normal" htmlFor={CUSTOMER_SEARCH_TYPES?.phoneNumber}>
              {Texts?.phoneNumber}
            </Label>
          </span>
          <span className="mr-4 flex items-center">
            <RadioGroupItem
              value={CUSTOMER_SEARCH_TYPES?.customerIdentifier}
              id={CUSTOMER_SEARCH_TYPES?.customerIdentifier}
              className="mr-2 border-black"
            />
            <Label className="text-base font-normal" htmlFor={CUSTOMER_SEARCH_TYPES?.customerIdentifier}>
              {Texts?.customerIdentifier}
            </Label>
          </span>
          <span className="mr-4 flex items-center">
            <RadioGroupItem
              value={CUSTOMER_SEARCH_TYPES?.emailAddress}
              id={CUSTOMER_SEARCH_TYPES?.emailAddress}
              className="mr-2 border-black"
            />
            <Label className="text-base font-normal" htmlFor={CUSTOMER_SEARCH_TYPES?.emailAddress}>
              {Texts?.emailAddress}
            </Label>
          </span>
          <span className="mr-4 flex items-center">
            <RadioGroupItem
              value={CUSTOMER_SEARCH_TYPES?.zipFnameLname}
              id={CUSTOMER_SEARCH_TYPES?.zipFnameLname}
              className="mr-2 border-black"
            />
            <Label className="text-base font-normal" htmlFor={CUSTOMER_SEARCH_TYPES?.zipFnameLname}>
              {Texts?.zipCodeFnameLname}
            </Label>
          </span>
        </span>
      </RadioGroup>
    </CardDescription>
  );
};

export default Index;
